<template>
  <FilterMultiChip
    is-text
    :label-mode="labelMode"
    icon="label-variant-outline"
    :label="$t('search-filters.status.name')"
    :items="items"
    :value="value || []"
    @change="$emit('change', $event)"
  />
</template>

<script>
import FilterMultiChip from '@/components/filters/FilterMultiChip';
import { LABEL_MODE } from '@/components/filters/label-mode';

/**
 * Opportunity-status dimension chip. Presentational: `:value` (array of status ids) + `:statuses`
 * (the status list the page owns) in, `change` out. Builds options from the passed-in statuses —
 * no store reach-in.
 */
export default {
  name: 'OpportunityStatusChip',
  components: { FilterMultiChip },
  props: {
    value: { type: Array, default: () => [] },
    statuses: { type: Array, default: () => [] },
  },
  computed: {
    labelMode: () => LABEL_MODE.COLLAPSE,
    items() {
      return (this.statuses || []).map((status) => ({ value: status.id, text: status.name }));
    },
  },
};
</script>
